module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-4-92222abe1470e3e9208e55a6973f66d2.svg";